import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RtTripErrorComponent } from './rt-trip-error.component';
import { BourqueCoreModule } from '@bds/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { BdsCommodityModule } from '@bds/commodity';
import {
    BdsDialogInfoModule,
    BdsDxDataGridModule,
    FormlyFieldTemplatesModule,
    ZeroPadModule,
} from '@bds/components';
import { BdsCustomerModule } from '@bds/customer';
import { BdsHelpersModule } from '@bds/helpers';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyMatDatepickerModule } from '@ngx-formly/material/datepicker';
import { DevExtremeModule } from 'devextreme-angular';
import {
    EquipmentReportCategoriesDialogModule,
    EquipmentReportCategoriesModule,
} from '../../../../bds-equipment/src';
import { BdsHotListSharedModule } from '../../../../bds/hotlist/src/public-api';
import { BdsRouteModule, RtRouteScreenModule } from '../../../../bds/route/src/public-api';
import {
    BdsSmartComponentsModule,
    BdsDateTimePickerModule,
} from '../../../../bds/smart-components/src/public-api';
import { RailtracClmModule } from '../railtrac-clm/railtrac-clm.module';
import { RtCommodityShippedModule } from '../rt-commodity-shipped/rt-commodity-shipped.module';
import { RtDiversionModule } from '../rt-diversion';
import { RtTripCommentModule } from '../rt-trip-comment/rt-trip-comment.module';
import { RtTripErrorMultiComponent } from './rt-multi-trip/rt-trip-error-multi.component';
import { RailtracTripModule } from '../railtrac-trip/railtrac-trip.module';
import { RtTripErrorDetailsComponent } from './rt-trip-error-details/rt-trip-error-details.component';
import { RtTripErrorMoreOptionsComponent } from './rt-trip-error-more-options/rt-trip-error-more-options.component';

@NgModule({
    declarations: [
        RtTripErrorComponent,
        RtTripErrorMultiComponent,
        RtTripErrorDetailsComponent,
        RtTripErrorMoreOptionsComponent,
    ],
    imports: [
        CommonModule,
        BourqueCoreModule,
        MatButtonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatSlideToggleModule,
        FormsModule,
        ReactiveFormsModule,
        BdsCommodityModule,
        BdsCustomerModule,
        BdsDialogInfoModule,
        BdsDxDataGridModule,
        EquipmentReportCategoriesDialogModule,
        EquipmentReportCategoriesModule,
        BdsHelpersModule,
        BdsHotListSharedModule,
        BdsSmartComponentsModule,
        BourqueCoreModule,
        CommonModule,
        DevExtremeModule,
        FontAwesomeModule,
        FormlyFieldTemplatesModule,
        FormlyMatDatepickerModule,
        FormlyMaterialModule,
        FormlyModule,
        FormsModule,
        MatBadgeModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatRadioModule,
        MatSelectModule,
        MatSidenavModule,
        MatSnackBarModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        RailtracClmModule,
        ReactiveFormsModule,
        RouterModule,
        RtCommodityShippedModule,
        RtDiversionModule,
        BdsRouteModule,
        RtRouteScreenModule,
        RtTripCommentModule,
        BdsDateTimePickerModule,
        ZeroPadModule,
        RailtracTripModule,
    ],
    exports: [
        MatButtonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatSlideToggleModule,
        RtTripErrorComponent,
        RtTripErrorDetailsComponent,
        RtTripErrorMultiComponent,
        RtTripErrorMoreOptionsComponent,
    ],
})
export class RtTripErrorModule {}
